import classes from "./CustomButton.module.css";

const CustomButton = (props) => {
  return (
    <div
      onClick={props.onClick}
      className={`${classes[props.type]}`}
      style={{ width: props.width, height: props.height }}
    >
      {props.content}
    </div>
  );
};

export default CustomButton;
